import React from 'react';
import { motion } from 'framer-motion';
const questions = ['¿Cuántas veces prometiste empezar y no lo hiciste?', '¿Cuánto tiempo más vas a culpar a las circunstancias?', '¿Realmente querés resultados o solo querés sentir motivación?', '¿Tu problema es capacidad… o carácter?', 'Si seguís así 6 meses más, ¿te respetarías?'];
export function DiscomfortSection() {
  return <section className="py-24 bg-[#0a0a0a] relative" data-id="element-20">
      <div className="container mx-auto px-4" data-id="element-21">
        <div className="mb-16 text-center" data-id="element-22">
          <span className="text-[#C9A84C] font-bold tracking-widest text-sm uppercase border-b border-[#C9A84C] pb-1" data-id="element-23">
            ¿Seguís mintiendo?
          </span>
        </div>

        <div className="max-w-4xl mx-auto space-y-8" data-id="element-24">
          {questions.map((q, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="group flex items-start gap-4 p-5 border-l-2 border-[#C9A84C]/30 hover:border-[#C9A84C] transition-colors bg-white/5 hover:bg-white/10" data-id="element-25">
              <span className="text-3xl font-['Bebas_Neue'] text-[#C9A84C]/50 group-hover:text-[#C9A84C] transition-colors shrink-0" data-id="element-26">
                0{i + 1}
              </span>
              <h3 className="text-lg md:text-3xl font-medium text-gray-200 group-hover:text-white transition-colors leading-snug" data-id="element-27">
                {q}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}